// src/theme/GlobalStyle.tsx (혹은 기존 GlobalStyle 파일)
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    /* 기본 라이트 테마 */
    --color-bg: #ffffff;
    --color-card: #ffffff;
    --color-surface: #f9fafb;
    --color-text: #111827;
    --color-muted: #6b7280;
    --color-border: rgba(0,0,0,0.06);

    /* ✅ 브랜드 컬러 */

    --color-accent-foreground: #ffffff;  /* 버튼 텍스트 */

    /* 살짝 진한 톤(호버/눌림용) */

    --color-accent: #7CB89A;
  --color-accent-600: #63A583;
  --color-accent-700: #4D8C6D;

    --color-avatar-bg: #F3F5F7;

    /* 상태 색상 */
    --color-success: #22c55e;
    --color-danger:  #ef4444;
    --color-warning: #facc15;

    --radius-md: 12px;
    --shadow-sm: 0 4px 12px rgba(0,0,0,0.08);
  }

  [data-theme="dark"] {
    --color-bg: #111214;
    --color-card: #1c1d20;
    --color-surface: #27282c;
    --color-text: #f9fafb;
    --color-muted: #9ca3af;
    --color-border: #33353b;

    /* ✅ 다크에서도 동일 브랜드 컬러 유지 */

    --color-accent-foreground: #ffffff;
    --color-accent: #7CB89A;
  --color-accent-600: #63A583;
  --color-accent-700: #4D8C6D;

    --color-success: #22c55e;
    --color-danger:  #ef4444;
    --color-warning: #facc15;
  }

  html, body, #root {
    margin: 0; padding: 0; min-height: 100%;
    background: var(--color-bg); color: var(--color-text);
    overflow-x: hidden;
 
  }


  

  img, video { max-width: 100%; height: auto; display: block; }
  body { overflow-y: auto; overflow-x: hidden; }
  *, *::before, *::after { box-sizing: border-box; }

  button { font-family: inherit; background: none; border: none; padding: 0; cursor: pointer; }
  a { color: inherit; text-decoration: none; }

  @keyframes spin {
  to {
        transform: rotate(360deg);
    }
  }


  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-thumb { background: var(--color-border); border-radius: 4px; }
`;
export default GlobalStyle;
